/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const DollarSymbol = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 1C18.0751 1 23 5.92486 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12C1 5.92486 5.92486 1 12 1ZM12 2.65C6.83614 2.65 2.65 6.83614 2.65 12C2.65 17.1638 6.83614 21.35 12 21.35C17.1638 21.35 21.35 17.1638 21.35 12C21.35 6.83614 17.1638 2.65 12 2.65ZM12.7341 6V7.1974C14.3219 7.43167 15.3761 8.44685 15.4803 9.9436H13.7623C13.6451 9.2538 13.0204 8.68113 12.0182 8.68113C11.0941 8.68113 10.5475 9.05857 10.5475 9.70933C10.5475 10.282 10.964 10.5553 11.6017 10.7375L13.1375 11.167C14.4521 11.5445 15.5714 12.1692 15.5714 13.9783C15.5714 15.4751 14.4781 16.5033 12.7341 16.6985V18H11.2764V16.6594C9.63644 16.3731 8.50412 15.1887 8.4 13.4707H10.118C10.1961 14.4599 11.0421 15.2148 12.1093 15.2148C13.1115 15.2148 13.8013 14.7332 13.8013 14.0174C13.8013 13.3796 13.3197 13.0152 12.669 12.833L11.1332 12.4035C9.84468 12.039 8.76443 11.3753 8.76443 9.72234C8.76443 8.42082 9.77961 7.44469 11.2764 7.1974V6H12.7341Z"
                        fill={color}
                    />
                </svg>
        );
    };
